'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { PaymentReturnHandler } from '@/components/subscription/PaymentReturnHandler';

export function PaymentReturnRedirector() {
  const pathname = usePathname();
  const searchParams = useSearchParams()!;
  const orderId = searchParams.get('order_id');
  if (searchParams.get('payment') !== 'pending' || !orderId) return null;

  const returnParams = new URLSearchParams(searchParams.toString());
  returnParams.delete('payment');
  returnParams.delete('order_id');
  const returnTo = `${pathname}${returnParams.toString() ? `?${returnParams.toString()}` : ''}`;

  // Keep the user on the page where the purchase started. The handler closes
  // the order in the background and removes the transient query parameters.
  return <PaymentReturnHandler orderId={orderId} returnTo={returnTo} />;
}
